module.exports = __webpack_public_path__ + "img/aec9bfd609f6a7afe0b926c0a98dd61a.png";